import { useMatch, useParams } from 'react-router-dom';
import { isCharacterHomeTab, type CharacterHomeTab } from '../tabs/character-home-tabs';

export interface CharacterHomeRoute {
    /** The tab the route shows. */
    activeTab: CharacterHomeTab;
    /** The crucible a /character/crucibles/:selectedId link names, if any. */
    selectedId: string | undefined;
    /** The invite code a /character/crucibles/join/:inviteCode link carries, if any. */
    inviteCode: string | undefined;
    /** Whether the route is /character/create. */
    isExplicitCreateRoute: boolean;
}

/** Which tab, and which crucible, the Character Home route shows. */
export function useCharacterHomeRoute(): CharacterHomeRoute {
    const { tab, selectedId, inviteCode } = useParams<{ tab?: string; selectedId?: string; inviteCode?: string }>();
    const isCreateRoute = useMatch('/character/crucibles/create');
    const isCruciblesWithSelectedRoute = selectedId !== undefined || inviteCode !== undefined;
    // A Journal replay, /character/journey/cutscenes/:cutsceneId, or a Compendium relive, /character/journey/visions/:visionId.
    const isJournalReplayRoute = useMatch('/character/journey/cutscenes/:cutsceneId') !== null;
    const isVisionReliveRoute = useMatch('/character/journey/visions/:visionId') !== null;
    const activeTab: CharacterHomeTab = isCreateRoute || isCruciblesWithSelectedRoute
        ? 'crucibles'
        : isJournalReplayRoute || isVisionReliveRoute ? 'journey' : (isCharacterHomeTab(tab) ? tab : 'overview');
    const isExplicitCreateRoute = useMatch('/character/create') !== null;

    return { activeTab, selectedId, inviteCode, isExplicitCreateRoute };
}
